import HtmlToReact, { Parser } from 'html-to-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { InlineBannerCta } from './InlineBannerCta';

const getWidgetComponent = node => {
  const text = node.data;
  const url = node.parent.attribs['data-url'];
  const btnText = node.parent.attribs['button-text'];
  return <InlineBannerCta href={url} description={text} btnText={btnText} />;
};

export default class WidgetHtmlParser extends Component<any, any> {
  static propTypes = {
    content: PropTypes.string
  };

  render() {
    const { content } = this.props;
    const isValidNode = function() {
      return true;
    };
    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    const processingInstructions = [
      {
        shouldProcessNode: function(node) {
          return (
            node.parent &&
            node.parent.name &&
            node.parent.name === 'span' &&
            node.parent.attribs &&
            node.parent.attribs['data-component']
          );
        },
        processNode: function(node) {
          return getWidgetComponent(node);
        }
      },
      {
        // Anything else
        shouldProcessNode: function() {
          return true;
        },
        processNode: processNodeDefinitions.processDefaultNode
      }
    ];
    const htmlToReactParser = new Parser();
    return (
      htmlToReactParser.parseWithInstructions(content, isValidNode, processingInstructions) || false
    );
  }
}
